import React from 'react';

function Message({ message }) {
  return (
    <div className="notification_col -text">
      <p>{message}</p>
    </div>
  )
}

export default Message;



// WEBPACK FOOTER //
// ./app/javascript/components/buy_support_panel/components/UI/Message.js